<template>
  <div>
    <div>
      <OrderTable />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderTable from "@/components/Order/OrderTableComponent.vue";

export default {
  name: "ViewOrderList",
  components: {
    OrderTable,
  },
  data() {
    return {};
  },
  computed: {
    username() {
      return this.$store.state.userInfo.userName;
    },
  },
};
</script>
